export default __webpack_public_path__ + "static/media/carina.b1d28001.jpg";